<app-main-resource-catalog [scope]="AppScope.COURSE"></app-main-resource-catalog>
